import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';

export class BuyFeatureButtonDisableUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('Game.command.buyFeature.disable');
        this.onExecuted?.();
    }

    getName(): string {
        return 'BuyFeatureButtonDisableUIAct';
    }
}